'use strict';

var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/router/hostname/static.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of the "hostname" component.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/router/hostname/StaticView#model
   * @type {actions/router/hostname/EditHostname}
   */

  template: twig({data: tpl}),
});
